import moment from 'moment';

export default {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
  },
  tooltips: {
    clear: 'Limpar',
    close: 'Fechar',
  },
  format: 'DD/MM/YYYY',
  locale: moment.locale('pt-BR'),
  showClear: true,
  showClose: true,
};
